import { ColorPalleteKey } from '../../app/utils/collorPallete'
import { IconPalleteKey } from '../../app/utils/iconPallete'
import {
  CreateLabelConnectionMutationVariables,
  LabelConnectionFragmentFragment,
  Maybe,
} from '../../graphql/generated'

export enum LabelBulkEditOptions {
  Inherit = 'inherit',
  Add = 'add',
  ReplaceBy = 'replaceBy',
  RemoveSelected = 'removeSelected',
  RemoveAll = 'removeAll',
}

export interface LabelType {
  id: string
  name: string
  description?: string
  colorKey?: ColorPalleteKey
  iconKey?: IconPalleteKey
}

export type LabelDetail =
  | Maybe<{
      id?: string | null
      name?: string | null
      colorKey?: string | null
      iconKey?: string | null
      createdAt?: Date | null
      description?: string | null
      labelConnectionsByLabelId?: {
        totalCount?: number
      }
    }>
  | undefined

export type LabelConnectionFragment =
  | LabelConnectionFragmentFragment
  | null
  | undefined

export type LabelKey = keyof CreateLabelConnectionMutationVariables
export type LabelViewExludedKey =
  | 'labelId'
  | 'recipientListId'
  | 'marketplaceOfferId'
  | 'cuzkEpoLienId'

export type LABEL_TAB_KEY =
  | Exclude<LabelKey, LabelViewExludedKey>
  | 'unassigned'
